"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrayMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _componentUtilities = require("@ux/component-utilities");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tray = _interopRequireDefault(require("./tray"));
var _trayButton = _interopRequireDefault(require("./tray-button"));
var _trayClose = _interopRequireDefault(require("./tray-close"));
var _classnames = _interopRequireDefault(require("classnames"));
var _intents = _interopRequireDefault(require("./intents.config"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function Style() {
  const css = `
    .tray-menu {
      --ux-trayMenu--backgroundColor: ${_intents.default.uxTrayMenu.backgroundColor};
      --ux-trayMenu--fontSize: ${_intents.default.uxTrayMenu.fontSize};
      --ux-trayMenuChosen--backgroundColor: ${_intents.default.uxTrayMenuChosen.backgroundColor};
      --ux-trayMenu-indicator--fontSize: ${_intents.default.uxTrayMenu.indicator.fontSize};
      --ux-trayMenu-indicator--fontWeight: ${_intents.default.uxTrayMenu.indicator.fontWeight};
      --ux-trayMenu-indicator--borderRadius: ${_intents.default.uxTrayMenu.indicator.borderRadius};
    }
  `;
  return /*#__PURE__*/_react.default.createElement("style", {
    type: "text/css"
  }, css);
}
const isDataAttr = /^data-[a-zA-Z0-9-]+$/;

/**
 * Tray menu component.
 *
 * This is the primary component for using the tray menu. It defines and renders
 * the button and establishes click handlers for toggling open the menu.
 *
 * @class TrayMenu
 * @public
 */
class TrayMenu extends _react.Component {
  constructor() {
    super(...arguments);
    const {
      open,
      trayAlignment
    } = this.props;
    this.state = {
      open: open || false,
      alignment: trayAlignment
    };
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.wrapperDiv = /*#__PURE__*/_react.default.createRef();
    this.trayMenuElement = /*#__PURE__*/_react.default.createRef();
  }

  /**
   * Hide the dropdown if clicks are outside the Tray itself.
   *
   * @api private
   */
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    if (!this.props.fullwidth && !this.state.alignment) {
      const alignment = this.getAlignment();
      this.setState({
        alignment
      });
    }
  }

  /**
   * Remove the attached event listener.
   *
   * @api private
   */
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      open
    } = this.state;
    const {
      trayAlignment
    } = this.props;
    if (trayAlignment && trayAlignment !== prevProps.trayAlignment) {
      this.setState({
        alignment: trayAlignment
      });
    } else if (open && open !== prevState.open) {
      const alignment = this.getAlignment();
      if (alignment !== prevState.alignment) {
        this.setState({
          alignment
        });
      }
    }
  }

  /**
   * Listen for the ESC key event.
   * @param {object} e the event object sent from the browser
   * @api private
   */
  handleKeyDown(e) {
    if (e.key && (e.key === 'Escape' || e.key === 'Esc')) {
      this.close();
    }
  }

  /**
   * Toggle tray menu and call any external listeners.
   *
   * @private
   */
  toggle() {
    const {
      onToggle
    } = this.props;
    const {
      open
    } = this.state;
    this.setState({
      open: !open
    }, () => {
      if (typeof onToggle === 'function') {
        onToggle(this.state.open);
      }
    });
  }

  /**
   * Close the tray.
   *
   * @api public
   */
  close() {
    if (this.state.open) {
      this.toggle();
    }
  }

  /**
   * Fetches all element bounds to necessary calculations of display
   * @private
   * @returns {object} element bounds
   */
  getElementBounds() {
    // Viewport Bounds
    const viewportBounds = {
      x: window.pageXOffset,
      y: window.pageYOffset,
      width: window.innerWidth,
      height: window.innerHeight
    };

    // Wrapper Div for Tray Menu
    const wrapperDivBounds = this.wrapperDiv && this.wrapperDiv.current.getBoundingClientRect();

    // Tray Menu Element
    const menuBounds = this.trayMenuElement && this.trayMenuElement.current && this.trayMenuElement.current.getBoundingClientRect();
    return {
      viewportBounds,
      wrapperDivBounds,
      menuBounds
    };
  }

  /**
   * Compute horizontal spacing for menu and determine whether to show aligned left or right to the tray menu.
   *
   * @returns {String|Boolean} The direction of alignment. False if neither left nor right.
   * @private
   */
  getAlignment() {
    let alignment = null;
    if (!this.props.fullwidth) {
      const {
        wrapperDivBounds,
        menuBounds,
        viewportBounds
      } = this.getElementBounds();
      if (wrapperDivBounds && menuBounds) {
        const right = wrapperDivBounds.left + viewportBounds.x - window.document.documentElement.clientLeft + menuBounds.width;
        // The element needs to be right aligned if it's too close or outside the bounds of the viewport
        // and it it small enough to fit inside a viewport, if it's too big we'll default to left
        if (viewportBounds.width - right < 10 && menuBounds.width < viewportBounds.width) {
          alignment = 'right';
        } else {
          // otherwise align left
          alignment = 'left';
        }
      }
    }
    return alignment;
  }

  /**
   * Collects `data-*` attributes from the given object and returns them in a new object
   *
   * @param  {Object} obj The object from which data attributes are collected
   * @returns {Object} Thec colleciton of data attributes
   * @api private
   */
  collectDataAttrs(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      if (isDataAttr.test(key)) {
        accumulator[key] = obj[key];
      }
      return accumulator;
    }, {});
  }

  /**
   * Render the tray menu
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  render() {
    const props = this.props;
    const dataAttrs = this.collectDataAttrs(props);
    const {
      open,
      alignment
    } = this.state;
    let alignMenuClass;
    if (!props.fullwidth) {
      alignMenuClass = alignment === 'left' ? 'tray-align-left' : 'tray-align-right';
    }
    const wrapperClassNames = (0, _classnames.default)('tray-menu', props.className, {
      open
    });
    const trayClassNames = (0, _classnames.default)(alignMenuClass, {
      'tray-fullwidth': props.fullwidth
    });
    return /*#__PURE__*/_react.default.createElement(_componentUtilities.ClickOutside, {
      onClick: this.close,
      targetRef: this.wrapperDiv
    }, /*#__PURE__*/_react.default.createElement(Style, null), /*#__PURE__*/_react.default.createElement("div", {
      className: wrapperClassNames,
      ref: this.wrapperDiv
    }, /*#__PURE__*/_react.default.createElement(_trayButton.default, {
      type: props.type,
      "aria-expanded": open,
      ariaLabel: props.ariaLabel,
      showOpenCaret: props.showOpenCaret,
      onClick: this.toggle,
      dataAttrs: dataAttrs,
      traySpanClass: props.traySpanClass,
      isOpen: open
    }, props.name), /*#__PURE__*/_react.default.createElement(_tray.default, {
      close: this.close,
      open: open,
      renderClosed: props.renderClosed,
      className: trayClassNames,
      ref: this.trayMenuElement
    }, props.showClose && /*#__PURE__*/_react.default.createElement(_trayClose.default, {
      onClick: this.toggle
    }), props.children)));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
exports.TrayMenu = TrayMenu;
TrayMenu.propTypes = {
  // Arbitrary data-* tags can be passed along, e.g. data-mix, data-eid, ...
  // 'data-*': PropTypes.string,
  ariaLabel: _propTypes.default.string,
  className: _propTypes.default.string,
  type: _propTypes.default.string,
  name: _propTypes.default.node.isRequired,
  children: _propTypes.default.node.isRequired,
  showOpenCaret: _propTypes.default.bool,
  open: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  fullwidth: _propTypes.default.bool,
  showClose: _propTypes.default.bool,
  renderClosed: _propTypes.default.bool,
  traySpanClass: _propTypes.default.string,
  trayAlignment: _propTypes.default.oneOf(['left', 'right'])
};

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
TrayMenu.defaultProps = {
  fullwidth: true,
  showClose: true,
  showOpenCaret: false,
  renderClosed: true
};
var _default = TrayMenu;
exports.default = _default;